



























helpers = require('../../helpers.coffee')

view_model = {
  components:
    templateForm: require '../templates/form'

  props:
    element_id:
      default: 'create-template-modal'

    action:
      type: FlowAction
      required: false

    template:
      default: -> {}

    options:
      type: Object

  data: ->
    template_kind: 'email'
    current_user: Session.current_user
    default_options:
      title: this.$t('template.actions.new')
      subtitle: ' '
      name: 'show'
      category: 'show'
      delete_button: false
      disable_buttons: false # disable send and save buttons

  computed:
    element_options: ->
      Object.assign({}, @default_options, @options || {})

    form_id: ->
      @element_id + '-form'

    form_options: ->
      name: @element_options.name
      category: @element_options.category
      show_footer: false
      focus: true
      modal: true
      preload: @element_options.preload
      from_flow: @element_options.from_flow

    has_template: ->
      @template != null && !jQuery.isEmptyObject(@template) && !Array.isArray(@template)

    template_or_default: ->
      if !@has_template
        new Template(signature: Session.current_user.signature, kind: @template_kind)
      else
        @template

  methods:
    show: (data) ->
      return unless data.id == @element_id
      @template_or_default.name = data.template_name
      @template_or_default.template_category_id = data.template_category_id
      @template_kind = data.template_kind

      @$refs.template_form.clear() unless @has_template
      jQuery("#" + @element_id).modal 'show'

    hide: ->
      jQuery("#" + @element_id).modal 'hide'

    cancel: ->
      @$emit 'cancel'
      @hide()

    submit: ->
      EventsBus.$emit 'TemplateForm:Submit'

    saveTemplate: (data) ->
      @bubbleUp(data)
      @hide()

    destroy: ->
      @$emit 'destroy'
      @hide()

  created: ->
    EventsBus.$on 'confirm-modal-show', @show

  beforeDestroy: ->
    EventsBus.$off 'confirm-modal-show', @show
}

exports.default = helpers.vue_include(
  view_model, helpers.form
)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/create_modal.vue